module.exports = __webpack_public_path__ + "/content/skins/HDemo/fonts/AcuraPerformance-Web-text/AcuraPerformance-Web.woff2";